'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  methods: {
    getPropsValues: function getPropsValues() {
      var _this = this;

      return _lodash2.default.mapValues(this.$options.props, function (v, k) {
        return _this[k];
      });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/dist/utils/getPropsValuesMixin.js
// module id = ./node_modules/vue2-google-maps/dist/utils/getPropsValuesMixin.js
// module chunks = 0